import { useEffect, useMemo } from 'react'
import { useAppDispatch } from '../../store/hooks'
import { useGetConfigQuery, useListFactorsQuery } from '../../store/mfa/mfa'
import { setupMFAForLogin } from '../../store/mfa/mfaSlice'
import { type SerializedToken, Token } from '../../common/token'
import { type AuthenticatedUser } from '../../models/User'

export const useMFAComplianceCheck = (user: AuthenticatedUser | null, userToken: SerializedToken | null): boolean => {
  const dispatch = useAppDispatch()

  const token = userToken ? Token.fromSerialized(userToken) : null
  const isFullAuthToken = !!token && token.tokenUse !== 'mfa'

  const { data: config } = useGetConfigQuery(user?.accountId ?? '', { skip: !user || !isFullAuthToken })
  const { data: factors } = useListFactorsQuery({ accountId: user?.accountId ?? '' }, { skip: !user || !isFullAuthToken })

  const isMFANonCompliant = useMemo(() => {
    if (!isFullAuthToken || !config?.mfaEnforced || !config?.factorType?.length || !factors) return false
    return !factors.some((f) => config.factorType!.includes(f.type))
  }, [isFullAuthToken, config, factors])

  useEffect(() => {
    if (isMFANonCompliant) dispatch(setupMFAForLogin())
  }, [isMFANonCompliant, dispatch])

  return isMFANonCompliant
}
